import currencies from '@shared/lib/ISO4217';
import Big from 'big.js';
import { set, unset, get, has, map, isEmpty } from 'lodash';

export function isArray(any) {
    return Array.isArray(any);
}

export function isObject(any) {
    return any !== null && typeof any === 'object';
}

export function mapObject(source, take) {
    const target = {};

    if (isArray(take)) {
        take.forEach((key) => {
            if (key in source) {
                target[key] = source[key];
            }
        });
    } else {
        Object.keys(take).forEach((sourceKey) => {
            const targetKey = take[sourceKey];

            if (sourceKey in source) {
                target[targetKey] = source[sourceKey];
            }
        });
    }

    return target;
}

export function each(obj, callback) {
    Object.keys(obj).forEach((key) => callback(obj[key], key));
}

export class ErrorBag {
    constructor(errors) {
        this._errors = typeof errors === 'object' ? errors : {};
    }

    has(key) {
        return this._errors.hasOwnProperty(key);
    }

    get(key) {
        const value = this._errors[key];

        if (isArray(value)) {
            return value.join(' ');
        }

        return value;
    }

    unset(key) {
        delete this._errors[key];
    }
}

export function extractPayload(payload) {
    return new Promise((resolve, reject) => {
        // Unhandled Javascript Error
        if (payload.response === undefined && payload.message !== undefined) {
            reject(new Error(payload.message));
            return;
        }
        // Platform error
        if (payload.response && payload.response.status !== 200) {
            reject(new Error(payload.response.status));
            return;
        }

        if (payload.status !== 200) {
            reject(new Error(payload.status));
            return;
        }

        // App Error
        if (payload.data && payload.data.hasOwnProperty('errorText')) {
            let err = new Error(payload.data.errorText);
            err.code = payload.data.code;
            err.status = payload.data.status;
            err.errorText = payload.data.errorText;
            reject(err);
            return;
        }

        // handle 200 error
        if (payload.data && payload.data.hasOwnProperty('error')) {
            // let errObj = {
            //     errorText: payload.data.error,
            //     code: payload.data.status
            // }
            let err = new Error(payload.data.error);
            console.log('has error', err)
            reject(err);
            return;
        }

        // OK
        if (payload.data && payload.data.hasOwnProperty('payload')) {
            resolve(payload.data.payload);
        }

        if (payload.data && payload.data.hasOwnProperty('token')) {
            resolve(payload.data.token);
        }
        if (payload.data && payload.data.hasOwnProperty('validatePass')) {
            resolve(payload.data.validatePass);
        }
    });
}

export function extractError(response) {
    return Promise.reject(response);
}

// Merge a single token
export function mergeToken(type, subpath) {
    return mergeField(type, 'token', subpath);
}

export function mergeField(type, mergeType, subpath) {
    let searchPath = subpath && subpath.length > 0 ? [subpath, type] : [type];
    let mergePath =
        subpath && subpath.length > 0 ? [subpath, mergeType] : [mergeType];

    return function(payload) {
        if (has(payload, searchPath) && has(payload, mergePath)) {
            let item = get(payload, searchPath);
            item[mergeType] = get(payload, mergePath);
            set(payload, searchPath, item);
            unset(payload, mergePath);
            return payload;
        }
        // console.warn('No', type, 'item')
        return payload;
    };
}

// Merge the tokens array with another array
export function mergeTokens(type) {
    return mergeFields(type, 'tokens', 'token');
}

export function mergeFields(type, groups, single, subpath) {
    let searchPath = subpath && subpath.length > 0 ? [subpath, type] : [type];
    let groupsPath = subpath && subpath.length > 0 ? [subpath, groups] : [groups];

    return function(payload) {
        if (has(payload, searchPath) && has(payload, groupsPath)) {
            set(
                payload,
                searchPath,
                map(get(payload, searchPath), (item, index) => {
                    item[single] = get(payload, [...groupsPath, index]);
                    return item;
                })
            );
            unset(payload, groupsPath);
            return payload;
        } else {
            // console.warn('No', type, 'items')
            return payload;
        }
    };
}

export function mergeIds(type) {
    const lookupKey = 'ids';
    const objectIdKey = 'id';
    return function(payload) {
        if (payload.hasOwnProperty(type) && payload.hasOwnProperty(lookupKey)) {
            let items = payload[type].map((item, index) => {
                item[objectIdKey] = payload[lookupKey][index];
                return item;
            });
            return items;
        } else {
            console.warn('No', type, 'items');
            return [];
        }
    };
}

export function amountFromApi({ value, currency }) {
    if (!isEmpty(currency)) {
        const currDef = currencies[currency];

        if (isEmpty(currDef)) {
            throw new Error('Unknown currency: ' + currency);
            return;
        }

        let factor = Math.pow(10, currDef.precision);
        let amount = Big(value).div(factor);
        return amount;
    } else {
        return value;
    }
}

export function amountToApi({ value, currency }) {
    if (!isEmpty(currency)) {
        const currDef = currencies[currency];

        if (isEmpty(currDef)) {
            throw new Error('Unknown currency: ' + currency);
            return;
        }

        let factor = Math.pow(10, currDef.precision);
        let amount = Big(value).times(factor);
        return amount;
    } else {
        return value;
    }
}

export function getUrlQueryValue(queryName) {
    let queryString = decodeURI(window.location.search.substring(1));
    let vars = queryString.split("&");
    for (let i = 0; i < vars.length; i++) {
        let pair = vars[i].split("=");
        if (pair[0] == queryName) { return pair[1]; }
    }
    return null;
}



// WEBPACK FOOTER //
// ./shared/utils.js